import { heatItems } from "@/mocks/gua";

const deltaIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-foreground-400" },
  flat: { icon: "ri-arrow-right-line", cls: "text-foreground-400" },
};

export default function HeatRank() {
  return (
    <section id="heat" className="scroll-mt-28 bg-background-100/70">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-12">
        {/* 榜头 */}
        <div className="lg:col-span-4">
          <p className="text-xs font-medium tracking-[0.3em] text-accent-700">04 / 实时热度榜</p>
          <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            本周热议
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            以全网讨论与站内跟踪加权计算的负面新闻与争议事件热度排行，每小时刷新一次区间。
          </p>
          <div className="mt-6 flex flex-col gap-3 border-l-2 border-accent-500 pl-4">
            <p className="font-display text-4xl font-black text-foreground-950">28.4<span className="text-xl">万</span></p>
            <p className="text-sm text-foreground-600">本周最高热度关键词「温叙白声明三改」，仍在爬升。</p>
          </div>
        </div>

        {/* 排行 */}
        <ol className="lg:col-span-8">
          {heatItems.map((h) => {
            const d = deltaIcon[h.delta];
            return (
              <li
                key={h.id}
                className="group flex items-center gap-4 border-b border-background-200 py-4 last:border-b-0"
              >
                <span
                  className={`w-9 shrink-0 text-center font-display text-2xl font-black ${
                    h.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                  }`}
                >
                  {String(h.rank).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-3">
                    <p className="truncate text-base font-medium text-foreground-950">{h.keyword}</p>
                    <span className="hidden shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 sm:inline-block">
                      {h.tag}
                    </span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <span
                      className={`block h-full rounded-full bg-accent-500 transition-all ${h.ratio >= 88 ? "" : "opacity-90"}`}
                      style={{ width: `${h.ratio}%` }}
                    />
                  </div>
                </div>
                <div className="flex w-24 shrink-0 flex-col items-end gap-1">
                  <span className="whitespace-nowrap text-xs font-medium text-foreground-700">{h.heat}</span>
                  <span className={`flex items-center gap-0.5 text-xs ${d.cls}`}>
                    <i className={`${d.icon} text-sm`} />
                    {h.delta === "up" ? "上升" : h.delta === "down" ? "回落" : "持平"}
                  </span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}